/* UmproTech Stage 11 — RFQ intake hydration.
   Adds source/UTM/product context to quote/contact forms. Idempotent and section-load safe. */
(function(){
  if (window.__utRfqIntakeRuntime) return;
  window.__utRfqIntakeRuntime = true;

  function setHidden(form, name, value){
    if (!form || !name) return;
    var selector = 'input[name="contact[' + name.replace(/"/g, '') + ']"]';
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[' + name + ']';
      form.appendChild(input);
    }
    input.value = value || '';
  }

  function hydrateForm(form, params){
    if (!form || form.getAttribute('data-ut-rfq-intake-hydrated') === 'true') return;
    setHidden(form, 'Source URL', window.location.href);
    setHidden(form, 'Landing Path', window.location.pathname);
    setHidden(form, 'Referrer', document.referrer || '');
    if (document.body) {
      setHidden(form, 'Page Type', document.body.getAttribute('data-page-type') || '');
      setHidden(form, 'Template Suffix', document.body.getAttribute('data-template-suffix') || '');
      setHidden(form, 'Route Handle', document.body.getAttribute('data-route-handle') || '');
    }
    ['product','collection','source','utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','msclkid','fbclid'].forEach(function(key){
      var value = params.get(key);
      if (value) setHidden(form, key.replace(/_/g,' ').toUpperCase(), value);
    });
    form.setAttribute('data-ut-rfq-intake-hydrated', 'true');
  }

  function hydrate(){
    var params = new URLSearchParams(window.location.search || '');
    document.querySelectorAll('form[action*="/contact"], form.ut-rq-form, form[data-umpro-rfq-form]').forEach(function(form){
      hydrateForm(form, params);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate); else hydrate();
  document.addEventListener('shopify:section:load', hydrate);
})();
